import { v4 as uuid } from 'uuid';
import { makeObservable, observable } from 'mobx';

export type TaskViewType = 'list' | 'kanban';

const VIEW_TYPE_STORAGE_KEY = 'tasks.viewType';

class TaskGroupingStore {
  groupingKey = '';
  groupBy = 'status';
  viewType: TaskViewType = 'list';

  constructor() {
    this.viewType = this._readViewType();

    makeObservable(this, {
      groupingKey: observable,
      groupBy: observable,
      viewType: observable,
    });
  }

  private _readViewType(): TaskViewType {
    try {
      const stored = localStorage.getItem(VIEW_TYPE_STORAGE_KEY);
      return stored === 'kanban' ? 'kanban' : 'list';
    } catch {
      return 'list';
    }
  }

  private _setGroupingKey() {
    this.groupingKey = uuid();
  }

  triggerRender() {
    this._setGroupingKey();
  }

  setGroupBy(groupBy: any) {
    this.groupBy = groupBy;
  }

  setViewType(viewType: TaskViewType) {
    this.viewType = viewType;

    try {
      localStorage.setItem(VIEW_TYPE_STORAGE_KEY, viewType);
    } catch {
      /* localStorage may be unavailable (e.g. private mode) — ignore */
    }
  }
}

export const taskGroupingStore = new TaskGroupingStore();
